import { render, staticRenderFns } from "./Tipo_AT.vue?vue&type=template&id=89fc3970&"
import script from "./Tipo_AT.vue?vue&type=script&lang=js&"
export * from "./Tipo_AT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports